module.exports = "https://retros.devl.appslatam.com/images/ticket.png?ea2f45a983af48f9ef2e2fd0eea81bf5";